import { __extends } from "tslib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
import React from "react";
var ButtonWithIcon = (function (_super) {
    __extends(ButtonWithIcon, _super);
    function ButtonWithIcon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var _a = _this.props, disabled = _a.disabled, onClick = _a.onClick;
            if (onClick && !disabled) {
                onClick();
            }
        };
        return _this;
    }
    ButtonWithIcon.prototype.render = function () {
        var _a = this.props, styleClasses = _a.styleClasses, disabled = _a.disabled, icon = _a.icon, title = _a.title, style = _a.style;
        return (React.createElement("a", { className: classnames({
                btn: true,
                disabled: disabled,
            }, styleClasses), style: style, onClick: this.onClick },
            React.createElement("i", null,
                React.createElement(FontAwesomeIcon, { icon: icon })),
            title));
    };
    return ButtonWithIcon;
}(React.PureComponent));
export { ButtonWithIcon };
